import React from 'react'
import { SimpleModal } from 'components/Modal'

interface Props {
  isOpen: boolean
  dateKey: string
  marked: boolean
  canChangeHours: boolean
  onChangeHours: () => void
  onRemoveDate: () => void
  onClose: () => void
}

const InstaBookOptionsModal: React.FC<Props> = ({ isOpen, dateKey, marked, canChangeHours, onChangeHours, onRemoveDate, onClose }) => {
  return (
    <SimpleModal isOpen={isOpen} onClose={onClose}>
      <div style={{ padding: '1rem' }}>
        <h3 style={{ marginTop: 0 }}>Auto-book options</h3>
        <div style={{ color: 'var(--text-secondary, #666)', marginBottom: '0.75rem' }}>
          Date: {dateKey}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {canChangeHours && (
            <button data-testid="autobook-change-hours" className="bigButtonInNewStyle" onClick={onChangeHours}>
              Change availability hours
            </button>
          )}
          {marked && (
            <button data-testid="autobook-remove-date" className="bigButtonInNewStyle" onClick={onRemoveDate} style={{ background: 'var(--primary-main, #FB7672)' }}>
              Remove This Date
            </button>
          )}
          <button className="bigButtonInNewStyle" onClick={onClose}>
            Go Back
          </button>
        </div>
      </div>
    </SimpleModal>
  )
}

export default InstaBookOptionsModal

